import { Link } from "react-router-dom";
import { latestVideos } from "@/mocks/videos";
import { sources } from "@/mocks/categories";

export default function LatestUpdate() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500 mt-2">每日更新，精彩不间断</p>
          </div>
        </div>

        <div className="flex items-center gap-3 mb-6 overflow-x-auto pb-2">
          <span className="text-xs text-foreground-500 whitespace-nowrap">来源：</span>
          {sources.map((source) => (
            <span
              key={source.slug}
              className="px-3 py-1.5 bg-background-200 text-foreground-700 text-xs rounded-full whitespace-nowrap font-medium cursor-pointer hover:bg-background-300 transition-colors"
            >
              {source.name}
            </span>
          ))}
        </div>

        <div className="space-y-3">
          {latestVideos.slice(0, 10).map((video, idx) => (
            <Link
              key={video.id}
              to={`/article/${video.id}`}
              className="flex items-center gap-4 p-4 rounded-xl bg-background-50 hover:bg-background-200/70 cursor-pointer transition-colors group"
            >
              <span className="text-lg font-bold text-foreground-300 w-8 text-center flex-shrink-0">
                {String(idx + 1).padStart(2, "0")}
              </span>
              <div className="w-16 h-20 md:w-20 md:h-28 flex-shrink-0 rounded-lg overflow-hidden bg-background-200">
                <img
                  src={video.image}
                  alt={video.title}
                  className="w-full h-full object-cover object-top"
                  title={`${video.title} - ${video.category}`}
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 group-hover:text-primary-500 transition-colors line-clamp-1">
                  {video.title}
                </h3>
                <div className="flex items-center gap-2 mt-1.5 flex-wrap">
                  <span className="px-2 py-0.5 bg-accent-100 text-accent-700 text-xs rounded-md font-medium">
                    {video.category}
                  </span>
                  <span className="text-xs text-foreground-500">{video.source}</span>
                  <span className="text-xs text-accent-600">
                    <i className="ri-star-fill text-xs mr-0.5"></i>
                    {video.rating}
                  </span>
                </div>
                <p className="text-xs text-foreground-500 mt-1.5 line-clamp-2 hidden sm:block">
                  {video.description}
                </p>
              </div>
              <div className="hidden sm:flex items-center gap-1 text-xs text-foreground-400 flex-shrink-0">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-500"></span>
                {video.updateTime}
              </div>
              <div className="flex-shrink-0">
                <i className="ri-play-circle-line text-2xl text-foreground-300 group-hover:text-primary-500 transition-colors"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}